export const DataBlick = ["#000000","#FDC219","#00BFF3","#F07AAE"]
export const NurielStone = ["#8175AA", "#6FB899", "#31A1B3", "#CCB22B", "#A39FC9", "#94D0C0", "#959C9E", "#027B8E", "#9F8F12"]
export const JewelBright = ["#EB1E2C","#FD6F30","#F9A729","#F9D23C","#F5BB68","#64CDCC","#91DCEA","#A4A4D5","#BBC9E5"]
export const defaultColor = ["#D3D3D3"]
export const demoColors = ["#000000"] // colorlogical
export const semioticDefault = ['#00a2ce','#4d430c','#b3331d','#b6a756']

export const colorsSankey = {
  Oil: "#b3331d",
  Gas: "rgb(182, 167, 86)",
  Coal: "#00a2ce",
  Other: "grey"
}
export const colors = [
  {palleteName: "Default Color", hexValues: defaultColor},
  {palleteName: "Demo Color", hexValues: defaultColor},
  {palleteName: "Nuriel Stone", hexValues: NurielStone},
  {palleteName: "Jewel Bright", hexValues: JewelBright},
  {palleteName: "DataBlick", hexValues: DataBlick},
  {palleteName: "Semiotic", hexValues: semioticDefault},
]

export const dematrixifiedEdges = [
  { source: "a", target: "a", value: 11975},
  { source: "a", target: "b", value: 5871},
  { source: "a", target: "c", value: 8916},
  { source: "a", target: "d", value: 2868},
  { source: "b", target: "a", value: 1951},
  { source: "b", target: "b", value: 10048},
  { source: "b", target: "c", value: 2060},
  { source: "b", target: "d", value: 6171},
  { source: "c", target: "a", value: 8010},
  { source: "c", target: "b", value: 16145},
  { source: "c", target: "c", value: 8090},
  { source: "c", target: "d", value: 8045},
  { source: "d", target: "a", value: 1013},
  { source: "d", target: "b", value: 990},
  { source: "d", target: "c", value: 940},
  { source: "d", target: "d", value: 6907},
]

export const dematrixifiedEdges1 = [
  { source: "a", target: "a", value: 10},
  { source: "a", target: "b", value: 10},
  { source: "a", target: "c", value: 10},
  { source: "b", target: "a", value: 10},
  { source: "b", target: "b", value: 10},
  { source: "b", target: "c", value: 10},
  { source: "c", target: "a", value: 10},
  { source: "c", target: "b", value: 10},
  { source: "c", target: "c", value: 10},
]

export const dematrixifiedEdges2 = [
  { source: "a", target: "a", value: 5},
  { source: "a", target: "b", value: 5},
  { source: "a", target: "c", value: 5},
  { source: "b", target: "a", value: 5},
  { source: "b", target: "b", value: 5},
  { source: "b", target: "c", value: 5},
  { source: "c", target: "a", value: 5},
  { source: "c", target: "b", value: 5},
  { source: "c", target: "c", value: 5},
]

export const dematrixifiedNodes = [
  { id: "a", color: DataBlick[0] },
  { id: "b", color: DataBlick[1] },
  { id: "c", color: DataBlick[2] },
  { id: "d", color: DataBlick[3] }
]

export const semioticTypes = {
  ["Chord"]: "chord",
  ["Network"]: "force",
  ["Sankey"]: "sankey",
  ["Matrix"]: "matrix",
  ["Arc"]: "arc",
}


// WEBPACK FOOTER //
// ./src/variables.js